import type { DBEquipmentBookingLine } from "@/lib/db-types";
import { formatDayRange } from "@/lib/equipment/availability";
import { lineLabel } from "@/lib/equipment/booking-draft";
import { upcomingLines } from "@/lib/equipment/occupancy";

interface OccupancyMobileListProps {
  lines: DBEquipmentBookingLine[];
  today: string;
  onOpenBooking: (bookingId: string) => void;
}

/** Belegg på mobil: «Booket i dag» og «Neste 7 dager» i stedet for rutenettet. */
export function OccupancyMobileList({ lines, today, onOpenBooking }: OccupancyMobileListProps) {
  const { today: now, nextWeek } = upcomingLines(lines, today);
  return (
    <div className="space-y-6">
      <Section title="Booket i dag" lines={now} empty="Ingenting er booket i dag." onOpenBooking={onOpenBooking} />
      <Section title="Neste 7 dager" lines={nextWeek} empty="Ingenting er booket de neste 7 dagene." onOpenBooking={onOpenBooking} />
    </div>
  );
}

function Section({ title, lines, empty, onOpenBooking }: { title: string; lines: DBEquipmentBookingLine[]; empty: string; onOpenBooking: (id: string) => void }) {
  return (
    <section className="space-y-2">
      <h2 className="font-display text-base font-semibold">{title}</h2>
      {lines.length === 0 ? (
        <p className="text-sm text-muted-foreground">{empty}</p>
      ) : (
        <ul className="divide-y divide-border rounded-md border">
          {lines.map((l) => (
            <li key={l.id}>
              <button type="button" className="flex w-full items-start justify-between gap-3 px-3 py-2.5 text-left text-sm hover:bg-muted/30" onClick={() => onOpenBooking(l.booking_id)}>
                <span className="min-w-0">
                  <span className="block font-medium">
                    {l.item_name}
                    {l.quantity > 1 ? ` × ${l.quantity}` : ""}
                  </span>
                  <span className="block text-xs text-muted-foreground">
                    {lineLabel(l)} · {l.item_department_name ?? "Ukjent avdeling"}
                  </span>
                </span>
                <span className="shrink-0 tabular-nums">{formatDayRange(l.date_from, l.date_to)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
